import { Switch } from "@mui/material";
import util, { FetchWithAuth } from "digimaker-ui/util";
import { useEffect, useMemo, useState } from "react";
import { Alert, Button, Form, Pagination, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

export const ListSchoolImage = () => {
  const [list, setList] = useState([]);
  const [schools, setSchools] = useState<Array<any>>([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState("");

  const [schoolID, setSchoolID] = useState(0);

  const itemsPerPage = 20;

  const getTotalPage = () => {
    return Math.ceil(count / itemsPerPage);
  };

  const fetchList = () => {
    FetchWithAuth(
      "matchfit/school-image/list?" +
        (schoolID ? "school_id=" + schoolID + "&" : "") +
        "limit=" +
        itemsPerPage +
        "&offset=" +
        (page - 1) * itemsPerPage
    ).then((data) => {
      setList(data.data.list);
      setCount(data.data.count);
    });
  };

  const previous = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const next = () => {
    if (page < getTotalPage()) {
      setPage(page + 1);
    }
  };

  const fetchSchools = () => {
    FetchWithAuth("matchfit/school/list?q=" + keyword).then((data) => {
      if (data.error === false) {
        setSchools(data.data);
      }
    });
  };

  useEffect(() => {
    fetchList();
  }, [schoolID, page]);

  const updateImage = (id, value) => {
    FetchWithAuth("content/update/image/" + id, {
      method: "POST",
      body: JSON.stringify(value),
    }).then((data) => {
      if (data.error === false) {
        fetchList();
      } else {
        window.alert(data.data.message);
      }
    });
    console.log(id, value);
  };

  const deleteImage = (id) => {
    FetchWithAuth("content/delete?type=image&cid=" + id, {
      method: "GET",
    }).then((data) => {
      if (data.error === false) {
        fetchList();
      } else {
        window.alert(data.data.message);
      }
    });
  };

  return (
    <div>
      <div>
        <div>
          <label>School search:</label>
          <input
            placeholder="Input to search"
            type="text"
            onChange={(e) => setKeyword(e.target.value)}
            value={keyword}
            style={{ width: 150, display: "inline-block", margin: "0px 5px" }}
            className="form-control"
          />
          <Button variant="secondary" onClick={() => fetchSchools()}>
            Search
          </Button>
          {schools.length > 0 && (
            <div style={{ display: "inline-block", marginLeft: 20 }}>
              <Form.Select
                className="form-control"
                onChange={(e) => setSchoolID(parseInt(e.target.value))}
              >
                <option value="">Select to show</option>
                {schools.map((item: any) => (
                  <option value={item.id}>{item.name}</option>
                ))}
              </Form.Select>
            </div>
          )}
        </div>
      </div>
      <br />
      <br />
      <div className="text-right">
        <div
          style={{
            display: "flex",
            marginBottom: 5,
            alignItems: "center",
            gap: 10,
            flexDirection: "row-reverse",
          }}
        >
          <Pagination>
            <Pagination.Prev onClick={() => previous()} />

            <Pagination.Next onClick={() => next()} />
          </Pagination>
          <div>
            <span>
              {page} / {getTotalPage()}
            </span>

            {schoolID > 0 && (
              <Link to={"/matchfit/school-image/add/" + schoolID}>
                <Button size="sm">Add image</Button>
              </Link>
            )}
          </div>
        </div>
      </div>
      <br />
      {list.length === 0 && <Alert>No image found</Alert>}
      {list.length > 0 && (
        <Table>
          <thead>
            <th>ID</th>
            <th>School</th>
            <th style={{ width: 80 }}>School id</th>
            <th>Image</th>
            <th>Is main</th>
            <th>Is sport</th>
            <th>Action</th>
          </thead>
          <tbody>
            {list.map((item: any) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.school_name}</td>
                <td>{item.school_id}</td>
                <td>
                  <img
                    style={{ height: 40 }}
                    src={util.washVariables(
                      process.env.REACT_APP_THUMB_PATH || "",
                      {
                        imagepath: item.image,
                      }
                    )}
                  />
                </td>
                <td>
                  <Switch
                    checked={item.is_main}
                    onChange={(e) =>
                      updateImage(item.id, {
                        is_main: e.target.checked ? 1 : 0,
                      })
                    }
                  />
                </td>
                <td>
                  <Switch
                    checked={item.is_sport}
                    onChange={(e) =>
                      updateImage(item.id, {
                        is_sport: e.target.checked ? 1 : 0,
                      })
                    }
                  />
                </td>
                <td>
                  <Link to={"/matchfit/school-image/update/" + item.id}>
                    Update
                  </Link>{" "}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      if (window.confirm("Are you sure to delete?")) {
                        deleteImage(item.id);
                      }
                    }}
                  >
                    Delete
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};
